/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { useTheme, Text } from "basis";
import { getProductName } from "library/transforms";
import { useEventTracking } from "react-event-tracker";
import { Chevron } from "../Chevron/Chevron";
import styles from "./product-accordion.module.scss";

export function ProductAccordion({
  product = {},
  isOpen = false,
  alwaysOpen = false,
  accountIdLabel = "",
  children,
}) {
  const { trackEvent } = useEventTracking();
  const theme = useTheme();
  const [open, setOpen] = useState(alwaysOpen || isOpen);
  const Tag = alwaysOpen ? "div" : "button";

  const productName = getProductName(product);

  return (
    <>
      <Tag
        className={styles.heading}
        style={{
          padding: `${theme.space[4]} 0 ${theme.space[4]} ${theme.space[5]}`,
          backgroundColor: theme.getColor("primary.blue.t100"),
          color: theme.getColor("white"),
        }}
        data-trackid="product-accordion"
        onClick={() => {
          setOpen((curOpen) => alwaysOpen || !curOpen);
          if (!open) {
            trackEvent({
              event: {
                category: "accordion",
                action: "in-page-navigation",
                location: "manage-my-account",
                label: productName,
              },
            });
          }
        }}
      >
        <div>
          <Text textStyle="heading5" color="white">
            {productName}
          </Text>
          {accountIdLabel && (
            <Text textStyle="body2" color="white" margin="2 0 0 0">
              {accountIdLabel}
            </Text>
          )}
        </div>
        {!alwaysOpen && (
          <div css={{ marginLeft: "auto" }}>
            <Chevron
              className={styles.chevron}
              direction={open ? "up" : "down"}
            />
          </div>
        )}
      </Tag>
      {open && children}
    </>
  );
}
